import axios from 'axios';

const url = '/api/v1/notifications';
export function getPaginated(pageNumber, pageSize) {
  const params = {
    per_page: pageSize,
    ...(pageNumber ? { page: pageNumber } : {}),
  };
  return axios.get(url, { params });
}

export function markRead(id) {
  return axios.post(`${url}/${id}/_mark_as_read`);
}

export function markUnread(id) {
  return axios.post(`${url}/${id}/_mark_as_unread`);
}

export function getUnreadCount() {
  return axios.get(`${url}/unread_count`);
}

export function markAllRead() {
  return axios.post(`${url}/_mark_all_as_read`);
}
